export class TypeformThemeHref {
    constructor(
        public href: string,
    ) {}

    static fromData(data: any): TypeformThemeHref {
        if (data === null || typeof data === 'string' || data instanceof TypeformThemeHref) {
            return data
        }

        return new TypeformThemeHref(
            data.href,
        )
    }
}
